import { BadgeProps } from "./types";

export const defaultBadges: BadgeProps[] = [
  { type: "popularBadge", text: "Popular", icon: "popular" },
  { type: "trendingBadge", text: "Trending", icon: "trending" },
  { type: "startDateBadge", text: "Start Date", icon: "start-date" },
  { type: "saleBadge", text: "Sale", icon: "sale" },
  { type: "dataBadge", text: "Data", icon: "data" },
  { type: "businessBadge", text: "Business", icon: "business" },
  { type: "aiBadge", text: "AI", icon: "ai" },
  { type: "noneBadge", text: "None", icon: "none" },
];
